/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import BasicContainer from '../../../components/BasicContainer';

const OptionButton = ({ label, onClick, disabled, className, icon, iconSize }) => (
  <BasicContainer
    className={`${className} cursor-pointer hover-container  bg-lighter px-3 mb-2 mb-md-0 ${
      disabled ? 'disabled-block' : ''
    }`}
    onClick={onClick}>
    <div className="d-flex flex-row align-items-center justify-content-between">
      <i className={`icon ${icon} ${iconSize} text-white`} />
      <div className="col-10 ms-2">
        <p>
          <b>{label}</b>
        </p>
      </div>
      <i
        style={{ width: '1rem' }}
        className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
        role="button"
        aria-label={label}
        tabIndex={0}
        onKeyDown={() => {}}
        onClick={() => {}}
      />
    </div>
  </BasicContainer>
);

export default OptionButton;

OptionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  iconSize: PropTypes.string.isRequired,
};

OptionButton.defaultProps = {
  label: null,
  disabled: null,
  className: '',
};
